<a class="logo-container" routerLink="/home">
  <mat-icon
    class="fill"
    [ngClass]="{ logo: !isMobile, 'logo-mobile': isMobile }"
    svgIcon="logo_rem"
  ></mat-icon>
</a>
